import { render, staticRenderFns } from "./Mingye_Vip.vue?vue&type=template&id=19a70faa&scoped=true"
import script from "./Mingye_Vip.vue?vue&type=script&lang=js"
export * from "./Mingye_Vip.vue?vue&type=script&lang=js"
import style0 from "./Mingye_Vip.vue?vue&type=style&index=0&id=19a70faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a70faa",
  null
  
)

export default component.exports